window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.BackDisabled = function() {
	this.initialize(img.MainAssets_BackDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BackDown = function() {
	this.initialize(img.MainAssets_BackDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.BackUp = function() {
	this.initialize(img.MainAssets_BackUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BigPanelBG = function() {
	this.initialize(img.MainAssets_BigPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1080,1743);


(lib.Boy = function() {
	this.initialize(img.MainAssets_Boy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,123,176);


(lib.Boy_ClosedEyes = function() {
	this.initialize(img.MainAssets_Boy_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,123,176);


(lib.Cabbage = function() {
	this.initialize(img.MainAssets_Cabbage);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,198,141);


(lib.Carrot = function() {
	this.initialize(img.MainAssets_Carrot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,203,111);


(lib.Caterpillar = function() {
	this.initialize(img.MainAssets_Caterpillar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,169,131);


(lib.Caterpillar_ClosedEyes = function() {
	this.initialize(img.MainAssets_Caterpillar_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,169,131);


(lib.CharacterShadow = function() {
	this.initialize(img.MainAssets_CharacterShadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,294,163);


(lib.Chicken = function() {
	this.initialize(img.MainAssets_Chicken);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,172,204);


(lib.Chicken__ClosedEyes = function() {
	this.initialize(img.MainAssets_Chicken__ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,172,204);


(lib.CloseButtonDis = function() {
	this.initialize(img.MainAssets_CloseButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,97);


(lib.CloseButtonhi = function() {
	this.initialize(img.MainAssets_CloseButtonhi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,97);


(lib.CloseButtonUp = function() {
	this.initialize(img.MainAssets_CloseButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,97);


(lib.Dog = function() {
	this.initialize(img.MainAssets_Dog);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,246,245);


(lib.Dog_ClosedEyes = function() {
	this.initialize(img.MainAssets_Dog_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,246,245);


(lib.Euromast = function() {
	this.initialize(img.MainAssets_Euromast);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,736,818);


(lib.Farmer = function() {
	this.initialize(img.MainAssets_Farmer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,183,330);


(lib.Farmer_ClosedEyes = function() {
	this.initialize(img.MainAssets_Farmer_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,183,330);


(lib.Father = function() {
	this.initialize(img.MainAssets_Father);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,164,235);


(lib.Father_ClosedEyes = function() {
	this.initialize(img.MainAssets_Father_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,164,235);


(lib.FeedbackPanelBg = function() {
	this.initialize(img.MainAssets_FeedbackPanelBg);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,225,75);


(lib.Ferry = function() {
	this.initialize(img.MainAssets_Ferry);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,676,533);


(lib.Ferry_ClosedEyes = function() {
	this.initialize(img.MainAssets_Ferry_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,676,533);


(lib.Ferry_Practice_RoundBG = function() {
	this.initialize(img.MainAssets_Ferry_Practice_RoundBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,470,167);


(lib.Fish_01 = function() {
	this.initialize(img.MainAssets_Fish_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,72,55);


(lib.Fish_02 = function() {
	this.initialize(img.MainAssets_Fish_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,82,62);


(lib.Foreground_Splash = function() {
	this.initialize(img.MainAssets_Foreground_Splash);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1332,2108);


(lib.Fox = function() {
	this.initialize(img.MainAssets_Fox);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,286,254);


(lib.Fox_ClosedEyes = function() {
	this.initialize(img.MainAssets_Fox_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,286,254);


(lib.Girl = function() {
	this.initialize(img.MainAssets_Girl);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,155,176);


(lib.Girl_ClosedEyes = function() {
	this.initialize(img.MainAssets_Girl_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,155,176);


(lib.Goat = function() {
	this.initialize(img.MainAssets_Goat);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,236,261);


(lib.Goat_ClosedEyes = function() {
	this.initialize(img.MainAssets_Goat_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,236,261);


(lib.Goose = function() {
	this.initialize(img.MainAssets_Goose);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,136,185);


(lib.Goose_ClosedEyes = function() {
	this.initialize(img.MainAssets_Goose_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,185);


(lib.Grass = function() {
	this.initialize(img.MainAssets_Grass);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,979,1586);


(lib.GreyBackground = function() {
	this.initialize(img.MainAssets_GreyBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,2108);


(lib.Kabouter = function() {
	this.initialize(img.MainAssets_Kabouter);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,900,703);


(lib.Kid = function() {
	this.initialize(img.MainAssets_Kid);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,122,176);


(lib.Kid_ClosedEyes = function() {
	this.initialize(img.MainAssets_Kid_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,122,176);


(lib.LongerMainButtonDis = function() {
	this.initialize(img.MainAssets_LongerMainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonDown = function() {
	this.initialize(img.MainAssets_LongerMainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonHi = function() {
	this.initialize(img.MainAssets_LongerMainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonUp = function() {
	this.initialize(img.MainAssets_LongerMainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.MainButtonDis = function() {
	this.initialize(img.MainAssets_MainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonDisMedium = function() {
	this.initialize(img.MainAssets_MainButtonDisMedium);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,450,124);


(lib.MainButtonDown = function() {
	this.initialize(img.MainAssets_MainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonDownMedium = function() {
	this.initialize(img.MainAssets_MainButtonDownMedium);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,450,124);


(lib.MainButtonHi = function() {
	this.initialize(img.MainAssets_MainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonHiMedium = function() {
	this.initialize(img.MainAssets_MainButtonHiMedium);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,450,124);


(lib.MainButtonUp = function() {
	this.initialize(img.MainAssets_MainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonUpMedium = function() {
	this.initialize(img.MainAssets_MainButtonUpMedium);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,450,124);


(lib.Mill = function() {
	this.initialize(img.MainAssets_Mill);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,715);


(lib.Mother = function() {
	this.initialize(img.MainAssets_Mother);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,236);


(lib.Mother_ClosedEyes = function() {
	this.initialize(img.MainAssets_Mother_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,236);


(lib.PopUpBG = function() {
	this.initialize(img.MainAssets_PopUpBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1032,1678);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.RacerTutorialPanel2 = function() {
	this.initialize(img.MainAssets_RacerTutorialPanel2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,802,224);


(lib.RacerTutorialPanel3 = function() {
	this.initialize(img.MainAssets_RacerTutorialPanel3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,992,462);


(lib.RacerTutorialPanel4 = function() {
	this.initialize(img.MainAssets_RacerTutorialPanel4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,992,570);


(lib.River = function() {
	this.initialize(img.MainAssets_River);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,1242);


(lib.RiverbankDown = function() {
	this.initialize(img.MainAssets_RiverbankDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,726,444);


(lib.RiverbankUp = function() {
	this.initialize(img.MainAssets_RiverbankUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,726,444);


(lib.SackGrain = function() {
	this.initialize(img.MainAssets_SackGrain);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,205);


(lib.Skip_disabled = function() {
	this.initialize(img.MainAssets_Skip_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,102);


(lib.Skip_down = function() {
	this.initialize(img.MainAssets_Skip_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,102);


(lib.Skip_up = function() {
	this.initialize(img.MainAssets_Skip_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,102);


(lib.SkipDown = function() {
	this.initialize(img.MainAssets_SkipDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,244,102);


(lib.SlotArea = function() {
	this.initialize(img.MainAssets_SlotArea);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,201,117);


(lib.Snail = function() {
	this.initialize(img.MainAssets_Snail);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,178,243);


(lib.Snail_ClosedEyes = function() {
	this.initialize(img.MainAssets_Snail_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,243);


(lib.Spider = function() {
	this.initialize(img.MainAssets_Spider);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,207,224);


(lib.Spider_ClosedEyes = function() {
	this.initialize(img.MainAssets_Spider_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,207,224);


(lib.SplashBGPanel = function() {
	this.initialize(img.MainAssets_SplashBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,739);


(lib.TabButtonBGBirds = function() {
	this.initialize(img.MainAssets_TabButtonBGBirds);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,204,100);


(lib.TabButtonBGBirdsDown = function() {
	this.initialize(img.MainAssets_TabButtonBGBirdsDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,204,100);


(lib.TabButtonBirdsIconDis = function() {
	this.initialize(img.MainAssets_TabButtonBirdsIconDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,116,140);


(lib.TabButtonBirdsIconUp = function() {
	this.initialize(img.MainAssets_TabButtonBirdsIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,116,140);


(lib.Tree = function() {
	this.initialize(img.MainAssets_Tree);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,778);


(lib.TutorialPanelArrow = function() {
	this.initialize(img.MainAssets_TutorialPanelArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,121,170);


(lib.White_LevelFill_Ferry = function() {
	this.initialize(img.MainAssets_White_LevelFill_Ferry);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,242,167);


(lib.WhiteArrow = function() {
	this.initialize(img.MainAssets_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);


(lib.Wolf = function() {
	this.initialize(img.MainAssets_Wolf);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,240,252);


(lib.Wolf_ClosedEyes = function() {
	this.initialize(img.MainAssets_Wolf_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,240,252);


(lib.Worm = function() {
	this.initialize(img.MainAssets_Worm);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,158,164);


(lib.Worm_ClosedEyes = function() {
	this.initialize(img.MainAssets_Worm_ClosedEyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,158,164);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.TutorialArrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutorialPanelArrow();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialArrow, new cjs.Rectangle(0,0,121,170), null);


(lib.RulesEats = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textfield = new cjs.Text("xeats", "39px 'Poppins Medium'", "#0F5184");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 69;
	this.textfield.lineWidth = 380;
	this.textfield.parent = this;
	this.textfield.setTransform(-1.6049,-31.1005);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RulesEats, new cjs.Rectangle(-193.4,-33.1,383.6,72.7), null);


(lib.RulesActorName = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textfield = new cjs.Text("xactorname", "39px 'Poppins Medium'", "#0F5184");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 69;
	this.textfield.lineWidth = 274;
	this.textfield.parent = this;
	this.textfield.setTransform(-1,-23.7);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RulesActorName, new cjs.Rectangle(-140.1,-25.7,278.2,72.7), null);


(lib.RiverbankUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RiverbankUp();
	this.instance.setTransform(0,0,1.8361,1.836);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RiverbankUp_1, new cjs.Rectangle(0,0,1333,815.2), null);


(lib.RiverbankDown_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RiverbankDown();
	this.instance.setTransform(0,0,1.8361,1.836);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RiverbankDown_1, new cjs.Rectangle(0,0,1333,815.2), null);


(lib.PracticeRoundLabel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.textfield = new cjs.Text("Practice \nround", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 59;
	this.textfield.lineWidth = 382;
	this.textfield.parent = this;
	this.textfield.setTransform(235.1,13.05);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// Layer_1
	this.instance = new lib.Ferry_Practice_RoundBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PracticeRoundLabel, new cjs.Rectangle(0,0,470,167), null);


(lib.PlaceholderRound = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.removeChildAt(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgTAUQgHgJgBgLQABgKAHgJQAJgHAKgBQALABAJAHQAHAJABAKQgBALgHAJQgJAHgLABQgKgBgJgHg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderRound, new cjs.Rectangle(-2.7,-2.7,5.5,5.5), null);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(47,47,47,0)").ss(4,2,1).p("EhmrikcMDNXAAAQCjAAAACbMAAAFECQAACcijAAMjNXAAAQijAAAAicMAAAlECQAAibCjAAg");
	this.shape.setTransform(673.475,1052.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0E95FD").s().p("EhmrCkdQijAAAAicMAAAlEBQAAicCjAAMDNXAAAQCjAAAACcMAAAFEBQAACcijAAg");
	this.shape_1.setTransform(673.475,1052.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-2,-2,1351,2109), null);


(lib.LevelDecoration = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {mill:0,tree:1,kabouter:2,euromast:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4));

	// Layer_1
	this.instance = new lib.Mill();
	this.instance.setTransform(-506.5,-357.5);

	this.instance_1 = new lib.Tree();
	this.instance_1.setTransform(-506.5,-357.5);

	this.instance_2 = new lib.Kabouter();
	this.instance_2.setTransform(-456,-312);

	this.instance_3 = new lib.Euromast();
	this.instance_3.setTransform(-386,-426);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-506.5,-426,1013,846.5);


(lib.GameScreenBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GreyBackground();
	this.instance.setTransform(-667,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenBackground, new cjs.Rectangle(-667,-1054,1334,2108), null);


(lib.ArrowButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.CloseButtonUp();
	this.instance.setTransform(-76.75,-46.85);

	this.instance_1 = new lib.CloseButtonhi();
	this.instance_1.setTransform(-76.5,-46.8);

	this.instance_2 = new lib.CloseButtonDis();
	this.instance_2.setTransform(-76.5,-46.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76.7,-46.8,153,97);


(lib.Fish_02_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish_02();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish_02_1, new cjs.Rectangle(0,0,82,62), null);


(lib.Fish_01_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish_01();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish_01_1, new cjs.Rectangle(0,0,72,55), null);


(lib.DummyTutorialStepPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("A9NvnMA6bAAAQCCAAAACCIAAbLQAACCiCAAMg6bAAAQiCAAAAiCIAA7LQAAiCCCAAg");
	this.shape.setTransform(0.1091,0,0.8104,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.549)").s().p("A9NPoQiCAAAAiCIAA7LQAAiCCCAAMA6bAAAQCCAAAACCIAAbLQAACCiCAAg");
	this.shape_1.setTransform(0.1091,0,0.8104,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DummyTutorialStepPanel, new cjs.Rectangle(-162.9,-101,326.1,202), null);


(lib.CharacterShadow_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterShadow();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CharacterShadow_1, new cjs.Rectangle(0,0,294,163), null);


(lib.CastPanelButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TabButtonBirdsIconUp();
	this.instance.setTransform(53,-24);

	this.instance_1 = new lib.TabButtonBirdsIconDis();
	this.instance_1.setTransform(53,-24);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).wait(1));

	// Layer_4
	this.instance_2 = new lib.TabButtonBGBirds();

	this.instance_3 = new lib.TabButtonBGBirdsDown();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-24,204,140);


(lib.BoatSeat = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SlotArea();
	this.instance.setTransform(-36,-20,0.3582,0.3582);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BoatSeat, new cjs.Rectangle(-36,-20,72,41.9), null);


(lib.Boat2Hitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CC6633").s().p("AlRCIIlSlBIgxilIGhENIBrA8IE6B8IFNAGIEVhCIjgD4IlyA8g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-72.4,-35.1,144.9,70.2);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-666,-1054,1.3643,1.0273);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667.4,-1055,1334.9,2110), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "39px 'Poppins SemiBold'", "#0F97FF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 70;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(0.0002,-35.25);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.instance = new lib.FeedbackPanelBg();
	this.instance.setTransform(-113,-38);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113,-38,225,75.3), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.StartGameButtonWide = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Weiter\nWeiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 386;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-97,-60);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Weiter\nWeiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 386;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-97,-60);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Weiter\nWeiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 386;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-97,-60);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Weiter\nWeiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 386;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-97,-60);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.LongerMainButtonUp();
	this.instance_1.setTransform(-309,-63);

	this.instance_2 = new lib.LongerMainButtonHi();
	this.instance_2.setTransform(-309,-63);

	this.instance_3 = new lib.LongerMainButtonDown();
	this.instance_3.setTransform(-311,-63);

	this.instance_4 = new lib.LongerMainButtonDis();
	this.instance_4.setTransform(-310,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-311,-63,520,127.5);


(lib.StartGameButtonMedium = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-58.55,-36);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-58.55,-36);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-58.55,-36);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-58.55,-36);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.MainButtonUpMedium();
	this.instance_1.setTransform(-241,-62);

	this.instance_2 = new lib.MainButtonHiMedium();
	this.instance_2.setTransform(-241,-62);

	this.instance_3 = new lib.MainButtonDownMedium();
	this.instance_3.setTransform(-241,-62);

	this.instance_4 = new lib.MainButtonDisMedium();
	this.instance_4.setTransform(-241,-62);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-241,-62,450,128);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.MainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.MainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,129);


(lib.SkipButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Button
	this.instance = new lib.Skip_up();
	this.instance.setTransform(-118.05,-56.65);

	this.instance_1 = new lib.Skip_down();
	this.instance_1.setTransform(-118.05,-56.65);

	this.instance_2 = new lib.SkipDown();
	this.instance_2.setTransform(-118,-57);

	this.instance_3 = new lib.Skip_disabled();
	this.instance_3.setTransform(-118.05,-56.65);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-118,-57,244,102.4);


(lib.TutorialStep7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "36px 'Poppins'");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.lineHeight = 63;
	this.actionTextfield.lineWidth = 885;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(-451.85,462.5479);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.bodyTextfield = new cjs.Text("try to keep the number of moves you make in a level to a minimum", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 891;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-458.05,66.85);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(353.2,-48.1,1,1,180,0,0,60.5,85);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.bodyTextfield},{t:this.actionTextfield}]}).wait(1));

	// Layer_2
	this.instance_1 = new lib.RacerTutorialPanel4();
	this.instance_1.setTransform(-509,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep7, new cjs.Rectangle(-509,-133.1,992,704.1), null);


(lib.TutorialStep4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.actionTextfield = new cjs.Text("Press to continue", "36px 'Poppins'");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.lineHeight = 63;
	this.actionTextfield.lineWidth = 917;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(-439.15,416.7479);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.bodyTextfield = new cjs.Text("You control the orange race car.\n\nYou can switch lanes by clicking the lane you want to move to.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 921;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-442.25,96.9479);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(397.75,4.3,1,1,180,0,0,60.5,85);

	this.instance_1 = new lib.RacerTutorialPanel3();
	this.instance_1.setTransform(-477,46);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance},{t:this.bodyTextfield},{t:this.actionTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep4, new cjs.Rectangle(-477,-80.7,992,588.7), null);


(lib.TutorialStep3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("You control the orange race car.\nYou can switch lanes by clicking the ", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 713;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-135.25,587.2979);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.RacerTutorialPanel2();
	this.instance.setTransform(-181,537);

	this.instance_1 = new lib.TutorialArrow();
	this.instance_1.setTransform(225.25,501.45,1,1,180,0,0,60.5,85);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep3, new cjs.Rectangle(-403,-511,1106.4,1764.3), null);


(lib.TutorialStep2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("Change your lane and see how your speed would change.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 713;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-574.45,-248.4521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(-212.65,-23.25,1,1,0,0,0,60.5,85);

	this.instance_1 = new lib.RacerTutorialPanel2();
	this.instance_1.setTransform(-620,-299);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep2, new cjs.Rectangle(-620,-299,802,360.8), null);


(lib.TutorialStep1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.bodyTextfield = new cjs.Text("Change your lane and see how your speed would change.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 713;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-338.65,80.8979);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(2.25,294.1,1,1,0,0,0,60.5,85);

	this.instance_1 = new lib.RacerTutorialPanel2();
	this.instance_1.setTransform(-386,30);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep1, new cjs.Rectangle(-386,30,802,349.1), null);


(lib.TutorialStep0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.startButton = new lib.StartGameButtonWide();
	this.startButton.name = "startButton";
	this.startButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 849;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-414.75,-506.6521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bodyTextfield},{t:this.titleTextfield},{t:this.startButton}]}).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhD6BoOQkrAAjTjTQjSjSAAkrMAAAi57QAAkrDSjSQDTjTErAAMCH1AAAQErAADSDTQDTDSAAErMAAAC57QAAErjTDSQjSDTkrAAg");
	this.shape.setTransform(0.025,-8.1601,1,1.2705);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_3
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-0.05,0.05,1.0218,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep0, new cjs.Rectangle(-690.8,-1074.7,1381.6999999999998,2149.5), null);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(276.45,626.3,1,1,0,0,0,0.1,0.1);

	this.bodyTextfield = new cjs.Text("Du hast das Ziel in 01:47:03 erreicht.", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(68.35,460.6473,0.9999,0.9999);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("Gut gemacht!", "bold 144px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 154;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(68.35,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.instance = new lib.SplashBGPanel();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.titleTextfield},{t:this.bodyTextfield},{t:this.button}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(0,0,1002,739), null);


(lib.LevelWith6SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from5 = new lib.PlaceholderRound();
	this.from5.name = "from5";
	this.from5.setTransform(-211.3,655.45);

	this.from4 = new lib.PlaceholderRound();
	this.from4.name = "from4";
	this.from4.setTransform(-360.85,566.35);

	this.from3 = new lib.PlaceholderRound();
	this.from3.name = "from3";
	this.from3.setTransform(-508.75,479.15);

	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-76.25,566.35);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-221.95,479.15);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-371.5,392.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2},{t:this.from3},{t:this.from4},{t:this.from5}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-198.3,235.35,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to5 = new lib.PlaceholderRound();
	this.to5.name = "to5";
	this.to5.setTransform(153.1,-301.45);

	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(299.55,-31.1,1,1,0,0,0,2,1);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(155.1,-118.8,1,1,0,0,0,2,1);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(6.15,-208.95);

	this.to3 = new lib.PlaceholderRound();
	this.to3.name = "to3";
	this.to3.setTransform(443.15,-125.3);

	this.to4 = new lib.PlaceholderRound();
	this.to4.name = "to4";
	this.to4.setTransform(292.05,-214.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to4},{t:this.to3},{t:this.to1},{t:this.to0},{t:this.to2},{t:this.to5}]}).wait(1));

	// fish etc
	this.instance = new lib.Fish_02_1();
	this.instance.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_1 = new lib.Fish_01_1();
	this.instance_1.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_2 = new lib.Fish_01_1();
	this.instance_2.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_3 = new lib.Fish_01_1();
	this.instance_3.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_4 = new lib.Fish_01_1();
	this.instance_4.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_5 = new lib.SlotArea();
	this.instance_5.setTransform(-312,600);

	this.instance_6 = new lib.SlotArea();
	this.instance_6.setTransform(-458,512);

	this.instance_7 = new lib.SlotArea();
	this.instance_7.setTransform(-605,425);

	this.instance_8 = new lib.SlotArea();
	this.instance_8.setTransform(-179,513);

	this.instance_9 = new lib.SlotArea();
	this.instance_9.setTransform(-325,425);

	this.instance_10 = new lib.SlotArea();
	this.instance_10.setTransform(-472,338);

	this.instance_11 = new lib.SlotArea();
	this.instance_11.setTransform(343,-184);

	this.instance_12 = new lib.SlotArea();
	this.instance_12.setTransform(197,-272);

	this.instance_13 = new lib.SlotArea();
	this.instance_13.setTransform(52,-359);

	this.instance_14 = new lib.SlotArea();
	this.instance_14.setTransform(198,-90);

	this.instance_15 = new lib.SlotArea();
	this.instance_15.setTransform(52,-178);

	this.instance_16 = new lib.SlotArea();
	this.instance_16.setTransform(-93,-265);

	this.instance_17 = new lib.Grass();
	this.instance_17.setTransform(-506,-659);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith6SlotsSkin, new cjs.Rectangle(-605,-782,1641,1709), null);


(lib.LevelWith5SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from4 = new lib.PlaceholderRound();
	this.from4.name = "from4";
	this.from4.setTransform(-288.95,616.75);

	this.from3 = new lib.PlaceholderRound();
	this.from3.name = "from3";
	this.from3.setTransform(-428.8,530.3);

	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-78.75,572);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-226.2,481.45);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-373.05,393.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2},{t:this.from3},{t:this.from4}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-198.3,235.35,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(302.15,-28,1,1,0,0,0,2,1);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(147.35,-120.75,1,1,0,0,0,2,1);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(4.15,-206.75);

	this.to4 = new lib.PlaceholderRound();
	this.to4.name = "to4";
	this.to4.setTransform(360.85,-180.75);

	this.to3 = new lib.PlaceholderRound();
	this.to3.name = "to3";
	this.to3.setTransform(206.2,-267.75);

	this.instance = new lib.SlotArea();
	this.instance.setTransform(108,-321);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(198,-90);

	this.instance_2 = new lib.SlotArea();
	this.instance_2.setTransform(52,-178);

	this.instance_3 = new lib.SlotArea();
	this.instance_3.setTransform(260,-236);

	this.instance_4 = new lib.SlotArea();
	this.instance_4.setTransform(-93,-265);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.to3},{t:this.to4},{t:this.to0},{t:this.to1},{t:this.to2}]}).wait(1));

	// fish etc
	this.instance_5 = new lib.Fish_02_1();
	this.instance_5.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_6 = new lib.Fish_01_1();
	this.instance_6.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_7 = new lib.Fish_01_1();
	this.instance_7.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_8 = new lib.Fish_01_1();
	this.instance_8.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_9 = new lib.Fish_01_1();
	this.instance_9.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_10 = new lib.SlotArea();
	this.instance_10.setTransform(-528,473);

	this.instance_11 = new lib.SlotArea();
	this.instance_11.setTransform(-389,559);

	this.instance_12 = new lib.SlotArea();
	this.instance_12.setTransform(-179,513);

	this.instance_13 = new lib.SlotArea();
	this.instance_13.setTransform(-325,425);

	this.instance_14 = new lib.SlotArea();
	this.instance_14.setTransform(-472,338);

	this.instance_15 = new lib.Grass();
	this.instance_15.setTransform(-506,-659);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith5SlotsSkin, new cjs.Rectangle(-528,-782,1564,1709), null);


(lib.LevelWith4SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from3 = new lib.PlaceholderRound();
	this.from3.name = "from3";
	this.from3.setTransform(-294.85,610.2);

	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-77.55,570.35);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-224.7,481.9);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-371.8,395.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2},{t:this.from3}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-198.3,235.35,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(297.4,-33.6);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(151.3,-121.55);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(4.15,-205.5);

	this.to3 = new lib.PlaceholderRound();
	this.to3.name = "to3";
	this.to3.setTransform(363,-176.45,1,1,0,0,0,2,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to3},{t:this.to0},{t:this.to1},{t:this.to2}]}).wait(1));

	// fish etc
	this.instance = new lib.Fish_02_1();
	this.instance.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_1 = new lib.Fish_01_1();
	this.instance_1.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_2 = new lib.Fish_01_1();
	this.instance_2.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_3 = new lib.Fish_01_1();
	this.instance_3.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_4 = new lib.Fish_01_1();
	this.instance_4.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_5 = new lib.SlotArea();
	this.instance_5.setTransform(-397,554);

	this.instance_6 = new lib.SlotArea();
	this.instance_6.setTransform(-179,513);

	this.instance_7 = new lib.SlotArea();
	this.instance_7.setTransform(-325,425);

	this.instance_8 = new lib.SlotArea();
	this.instance_8.setTransform(-472,338);

	this.instance_9 = new lib.SlotArea();
	this.instance_9.setTransform(198,-90);

	this.instance_10 = new lib.SlotArea();
	this.instance_10.setTransform(52,-178);

	this.instance_11 = new lib.SlotArea();
	this.instance_11.setTransform(-95,-265);

	this.instance_12 = new lib.SlotArea();
	this.instance_12.setTransform(260,-236);

	this.instance_13 = new lib.Grass();
	this.instance_13.setTransform(-506,-659);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith4SlotsSkin, new cjs.Rectangle(-506,-782,1542,1709), null);


(lib.LevelWith3SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from2 = new lib.PlaceholderRound();
	this.from2.name = "from2";
	this.from2.setTransform(-56.5,585.05);

	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-205.05,497.85);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-352,411.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1},{t:this.from2}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-103.05,299.8,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to2 = new lib.PlaceholderRound();
	this.to2.name = "to2";
	this.to2.setTransform(338.25,-20.6,1,1,0,0,0,2,1);

	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(190.35,-107.45);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(42.95,-194.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to0},{t:this.to1},{t:this.to2}]}).wait(1));

	// Slots
	this.instance = new lib.SlotArea();
	this.instance.setTransform(236,-77);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(90,-165);

	this.instance_2 = new lib.SlotArea();
	this.instance_2.setTransform(-57,-252);

	this.instance_3 = new lib.SlotArea();
	this.instance_3.setTransform(-158,525);

	this.instance_4 = new lib.SlotArea();
	this.instance_4.setTransform(-305,438);

	this.instance_5 = new lib.SlotArea();
	this.instance_5.setTransform(-452,352);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// fish etc
	this.instance_6 = new lib.Fish_02_1();
	this.instance_6.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_7 = new lib.Fish_01_1();
	this.instance_7.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_8 = new lib.Fish_01_1();
	this.instance_8.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_9 = new lib.Fish_01_1();
	this.instance_9.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_10 = new lib.Fish_01_1();
	this.instance_10.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_11 = new lib.Grass();
	this.instance_11.setTransform(-476,-599);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_11},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith3SlotsSkin, new cjs.Rectangle(-666,-782,1702,1769), null);


(lib.LevelWith2SlotsSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bank_from
	this.from1 = new lib.PlaceholderRound();
	this.from1.name = "from1";
	this.from1.setTransform(-48.5,572.05);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-197.05,484.85);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.from0},{t:this.from1}]}).wait(1));

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-103.05,299.8,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// bank_to
	this.to1 = new lib.PlaceholderRound();
	this.to1.name = "to1";
	this.to1.setTransform(190.35,-107.45);

	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(42.95,-194.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.to0},{t:this.to1}]}).wait(1));

	// Slots
	this.instance = new lib.SlotArea();
	this.instance.setTransform(90,-165);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(-57,-252);

	this.instance_2 = new lib.SlotArea();
	this.instance_2.setTransform(-150,512);

	this.instance_3 = new lib.SlotArea();
	this.instance_3.setTransform(-297,425);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// fish etc
	this.instance_4 = new lib.Fish_02_1();
	this.instance_4.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_5 = new lib.Fish_01_1();
	this.instance_5.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_6 = new lib.Fish_01_1();
	this.instance_6.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_7 = new lib.Fish_01_1();
	this.instance_7.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_8 = new lib.Fish_01_1();
	this.instance_8.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_9 = new lib.Grass();
	this.instance_9.setTransform(-476,-599);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith2SlotsSkin, new cjs.Rectangle(-666,-782,1702,1769), null);


(lib.LevelWith1SlotSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// boat placeholder
	this.boatTo = new lib.PlaceholderRound();
	this.boatTo.name = "boatTo";
	this.boatTo.setTransform(-1.35,123.85);

	this.boatFrom = new lib.PlaceholderRound();
	this.boatFrom.name = "boatFrom";
	this.boatFrom.setTransform(-103.05,299.8,1,1,0,0,0,0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.boatFrom},{t:this.boatTo}]}).wait(1));

	// Slots
	this.to0 = new lib.PlaceholderRound();
	this.to0.name = "to0";
	this.to0.setTransform(42.95,-194.35);

	this.instance = new lib.SlotArea();
	this.instance.setTransform(-57,-252);

	this.from0 = new lib.PlaceholderRound();
	this.from0.name = "from0";
	this.from0.setTransform(-56.5,585.05);

	this.instance_1 = new lib.SlotArea();
	this.instance_1.setTransform(-158,525);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.from0},{t:this.instance},{t:this.to0}]}).wait(1));

	// fish etc
	this.instance_2 = new lib.Fish_02_1();
	this.instance_2.setTransform(219.2,387.65,1,1,0,0,0,41,31);

	this.instance_3 = new lib.Fish_01_1();
	this.instance_3.setTransform(399.8,276,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_4 = new lib.Fish_01_1();
	this.instance_4.setTransform(394.1,233.95,1,1,0,0,0,36,27.5);

	this.instance_5 = new lib.Fish_01_1();
	this.instance_5.setTransform(-456.7,0.7,0.5812,0.5818,0,0,0,33.3,25);

	this.instance_6 = new lib.Fish_01_1();
	this.instance_6.setTransform(-416.35,-13.3,1,1,0,0,0,36,27.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// grass etc
	this.decoration = new lib.LevelDecoration();
	this.decoration.name = "decoration";
	this.decoration.setTransform(529.5,-424.5);

	this.instance_7 = new lib.Grass();
	this.instance_7.setTransform(-476,-599);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.decoration}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelWith1SlotSkin, new cjs.Rectangle(-666,-782,1702,1769), null);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// PracticeRoundLabel
	this.practiceIndicator = new lib.PracticeRoundLabel();
	this.practiceIndicator.name = "practiceIndicator";
	this.practiceIndicator.setTransform(-265,83.5,1,1,0,0,0,235,83.5);

	this.timeline.addTween(cjs.Tween.get(this.practiceIndicator).wait(1));

	// level
	this.levelLabelTextfield = new cjs.Text("Level", "39px 'Poppins Medium'", "#0F5184");
	this.levelLabelTextfield.name = "levelLabelTextfield";
	this.levelLabelTextfield.textAlign = "center";
	this.levelLabelTextfield.lineHeight = 70;
	this.levelLabelTextfield.lineWidth = 236;
	this.levelLabelTextfield.parent = this;
	this.levelLabelTextfield.setTransform(120.15,21.6);
ranj.TextOffsetFixer.fix(this.levelLabelTextfield);

	this.levelTextfield = new cjs.Text("1", "bold 39px 'Poppins'", "#0F5184");
	this.levelTextfield.name = "levelTextfield";
	this.levelTextfield.textAlign = "center";
	this.levelTextfield.lineHeight = 70;
	this.levelTextfield.lineWidth = 237;
	this.levelTextfield.parent = this;
	this.levelTextfield.setTransform(120.35,83.25);
ranj.TextOffsetFixer.fix(this.levelTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.levelTextfield},{t:this.levelLabelTextfield}]}).wait(1));

	// Layer_2
	this.instance = new lib.White_LevelFill_Ferry();
	this.instance.setTransform(-1,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-500,-24.1,741,191.1), null);


(lib.FailurePopupActorSlot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// img
	this.image = new lib.PlaceholderRound();
	this.image.name = "image";
	this.image.setTransform(0,12.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.image).wait(1));

	// text
	this.nameTextfield = new cjs.Text("whatsmyname", "39px 'Poppins Medium'", "#0F5184");
	this.nameTextfield.name = "nameTextfield";
	this.nameTextfield.textAlign = "center";
	this.nameTextfield.lineHeight = 69;
	this.nameTextfield.lineWidth = 313;
	this.nameTextfield.parent = this;
	this.nameTextfield.setTransform(-2.95,42.7);
ranj.TextOffsetFixer.fix(this.nameTextfield);

	this.timeline.addTween(cjs.Tween.get(this.nameTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FailurePopupActorSlot, new cjs.Rectangle(-161.5,-100.2,317.2,282.3), null);


(lib.Boat3Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.slot2 = new lib.PlaceholderRound();
	this.slot2.name = "slot2";
	this.slot2.setTransform(145,59.1);

	this.slot1 = new lib.PlaceholderRound();
	this.slot1.name = "slot1";
	this.slot1.setTransform(15.95,-16.5);

	this.slot0 = new lib.PlaceholderRound();
	this.slot0.name = "slot0";
	this.slot0.setTransform(-95,-81.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.slot0},{t:this.slot1},{t:this.slot2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Boat3Container, new cjs.Rectangle(-97.7,-83.8,245.5,145.7), null);


(lib.Boat2Container = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.slot1 = new lib.PlaceholderRound();
	this.slot1.name = "slot1";
	this.slot1.setTransform(98.15,35.4);

	this.slot0 = new lib.PlaceholderRound();
	this.slot0.name = "slot0";
	this.slot0.setTransform(-50.95,-43.05);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.slot0},{t:this.slot1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Boat2Container, new cjs.Rectangle(-53.7,-45.8,154.60000000000002,84), null);


(lib.WormSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {blink:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Worm();
	this.instance.setTransform(-64,-120);

	this.instance_1 = new lib.Worm_ClosedEyes();
	this.instance_1.setTransform(-64,-120);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-120,294,201);


(lib.WomanSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Mother();
	this.instance.setTransform(-67,-219);

	this.instance_1 = new lib.Mother_ClosedEyes();
	this.instance_1.setTransform(-67,-219);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-219,294,300);


(lib.WolfSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Wolf();
	this.instance.setTransform(-95,-234);

	this.instance_1 = new lib.Wolf_ClosedEyes();
	this.instance_1.setTransform(-95,-234);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-234,294,315);


(lib.SpiderSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Spider();
	this.instance.setTransform(-87,-137,0.8333,0.8333);

	this.instance_1 = new lib.Spider_ClosedEyes();
	this.instance_1.setTransform(-87,-137,0.8333,0.8333);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-137,294,218);


(lib.SnailSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Snail();
	this.instance.setTransform(-82,-164,0.8989,0.8988);

	this.instance_1 = new lib.Snail_ClosedEyes();
	this.instance_1.setTransform(-82,-164,0.8989,0.8988);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-164,294,245);


(lib.ManSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Father();
	this.instance.setTransform(-69,-219);

	this.instance_1 = new lib.Father_ClosedEyes();
	this.instance_1.setTransform(-69,-219);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-219,294,300);


(lib.Kid3Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Kid();
	this.instance.setTransform(-49,-158);

	this.instance_1 = new lib.Kid_ClosedEyes();
	this.instance_1.setTransform(-49,-158);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-158,294,239);


(lib.GooseSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Goose();
	this.instance.setTransform(-59,-174);

	this.instance_1 = new lib.Goose_ClosedEyes();
	this.instance_1.setTransform(-60,-174);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-174,294,255);


(lib.GoatSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Goat();
	this.instance.setTransform(-95,-243);

	this.instance_1 = new lib.Goat_ClosedEyes();
	this.instance_1.setTransform(-95,-243);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-243,294,324);


(lib.GirlSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Girl();
	this.instance.setTransform(-68,-158);

	this.instance_1 = new lib.Girl_ClosedEyes();
	this.instance_1.setTransform(-68,-158);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-158,294,239);


(lib.FoxSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Fox();
	this.instance.setTransform(-88,-234);

	this.instance_1 = new lib.Fox_ClosedEyes();
	this.instance_1.setTransform(-88,-234);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-234,343,315);


(lib.FarmerSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Farmer();
	this.instance.setTransform(-106,-297);

	this.instance_1 = new lib.Farmer_ClosedEyes();
	this.instance_1.setTransform(-106,-297);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-297,294,378);


(lib.DogSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Dog();
	this.instance.setTransform(-81,-225);

	this.instance_1 = new lib.Dog_ClosedEyes();
	this.instance_1.setTransform(-81,-225);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-225,310,306);


(lib.ChickenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Chicken();
	this.instance.setTransform(-54,-188);

	this.instance_1 = new lib.Chicken__ClosedEyes();
	this.instance_1.setTransform(-54,-188);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-188,294,269);


(lib.CaterpillarSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Caterpillar();
	this.instance.setTransform(-88,-79);

	this.instance_1 = new lib.Caterpillar_ClosedEyes();
	this.instance_1.setTransform(-88,-79);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-82,294,163);


(lib.CarrotSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.instance = new lib.Carrot();
	this.instance.setTransform(-75,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow_1();
	this.instance_1.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CarrotSkin, new cjs.Rectangle(-145,-82,294,163), null);


(lib.CabbageSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.instance = new lib.Cabbage();
	this.instance.setTransform(-102,-112);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow_1();
	this.instance_1.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CabbageSkin, new cjs.Rectangle(-145,-112,294,193), null);


(lib.BoySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Boy();
	this.instance.setTransform(-52,-164);

	this.instance_1 = new lib.Boy_ClosedEyes();
	this.instance_1.setTransform(-52,-164);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	// Shadow
	this.instance_2 = new lib.CharacterShadow_1();
	this.instance_2.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-145,-164,294,245);


(lib.Boat3SkinNoSeats = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat3Container();
	this.container.name = "container";
	this.container.setTransform(76.4,-76.85,1,1,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(98.75,-55.55,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance = new lib.Ferry();
	this.instance.setTransform(-243,-414);

	this.instance_1 = new lib.Ferry_ClosedEyes();
	this.instance_1.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,676,533);


(lib.Boat3Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat3Container();
	this.container.name = "container";
	this.container.setTransform(87.65,-75.45,1,1,0,0,0,-0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// seats
	this.instance = new lib.BoatSeat();
	this.instance.setTransform(231.65,-17.95,3,3);

	this.instance_1 = new lib.BoatSeat();
	this.instance_1.setTransform(105.85,-92.7,3,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(110.05,-54.15,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance_2 = new lib.Ferry();
	this.instance_2.setTransform(-243,-414);

	this.instance_3 = new lib.Ferry_ClosedEyes();
	this.instance_3.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,676,533);


(lib.Boat2SkinNoSeats = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat2Container();
	this.container.name = "container";
	this.container.setTransform(116.4,-52.85,1,1,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(98.75,-55.55,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance = new lib.Ferry();
	this.instance.setTransform(-243,-414);

	this.instance_1 = new lib.Ferry_ClosedEyes();
	this.instance_1.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,676,533);


(lib.Boat2Skin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"blink":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_9 = function() {
		this.gotoAndStop(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(1));

	// container
	this.container = new lib.Boat2Container();
	this.container.name = "container";
	this.container.setTransform(74.7,-81.35,1,1,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(10));

	// seats
	this.instance = new lib.BoatSeat();
	this.instance.setTransform(172.8,-45.8,3,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(10));

	// hitarea
	this.hit = new lib.Boat2Hitarea();
	this.hit.name = "hit";
	this.hit.setTransform(97.05,-60.05,3,3);
	this.hit.alpha = 0.0508;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(10));

	// graphic
	this.instance_1 = new lib.Ferry();
	this.instance_1.setTransform(-243,-414);

	this.instance_2 = new lib.Ferry_ClosedEyes();
	this.instance_2.setTransform(-243,-414);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243,-414,676,533);


(lib.BagSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.instance = new lib.SackGrain();
	this.instance.setTransform(-73,-173);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow_1();
	this.instance_1.setTransform(2,-0.5,1,1,0,0,0,147,81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BagSkin, new cjs.Rectangle(-145,-173,294,254), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textPanel
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// bg
	this.instance = new lib.Foreground_Splash();
	this.instance.setTransform(-666,-1054);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 54;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 54;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 54;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#DDE5EF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 54;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.BackUp();
	this.instance.setTransform(-152,-18);

	this.instance_1 = new lib.PrevNextButton();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.BackDown();
	this.instance_2.setTransform(-152,-18);

	this.instance_3 = new lib.BackDisabled();
	this.instance_3.setTransform(-152,-18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(17.95,0.3,2.8787,1.5699,0,0,0,0.1,0.1);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-158.6,-31,352.6,83.3);


(lib.TutorialStep8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.replayButton = new lib.PrevButton();
	this.replayButton.name = "replayButton";
	this.replayButton.setTransform(-262.3,736.05,1,1,0,0,0,17.7,10.6);

	this.startButton = new lib.StartGameButtonMedium();
	this.startButton.name = "startButton";
	this.startButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 849;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-414.75,-506.6521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhD6BoOQkrAAjTjTQjSjSAAkrMAAAi57QAAkrDSjSQDTjTErAAMCH1AAAQErAADSDTQDTDSAAErMAAAC57QAAErjTDSQjSDTkrAAg");
	this.shape.setTransform(0.025,-8.1601,1,1.2705);

	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-0.05,0.05,1.0218,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.shape},{t:this.bodyTextfield},{t:this.titleTextfield},{t:this.startButton},{t:this.replayButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep8, new cjs.Rectangle(-690.8,-1074.7,1381.6999999999998,2149.5), null);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.step0 = new lib.TutorialStep0();
	this.step0.name = "step0";
	this.step0.setTransform(-0.8,7.45);

	this.step1 = new lib.TutorialStep1();
	this.step1.name = "step1";
	this.step1.setTransform(-48.3,19.6,1,1,0,0,0,1.3,1);

	this.step2 = new lib.TutorialStep2();
	this.step2.name = "step2";
	this.step2.setTransform(219.7,571.85,1,1,0,0,0,1.3,1);

	this.step3 = new lib.TutorialStep3();
	this.step3.name = "step3";
	this.step3.setTransform(-150.1,-358.95,1,1,0,0,0,1.3,1);

	this.step4 = new lib.TutorialStep4();
	this.step4.name = "step4";
	this.step4.setTransform(-18.2,-551.6,1,1,0,0,0,-0.1,20.2);

	this.step5 = new lib.TutorialStep7();
	this.step5.name = "step5";
	this.step5.setTransform(29.75,-411.6,1,1,0,0,0,1.4,-1.1);

	this.step6 = new lib.TutorialStep8();
	this.step6.name = "step6";
	this.step6.setTransform(1.25,9.45);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.step0}]}).to({state:[{t:this.step1}]},1).to({state:[{t:this.step2}]},1).to({state:[{t:this.step3}]},1).to({state:[{t:this.step4}]},1).to({state:[{t:this.step5}]},1).to({state:[{t:this.step6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1653.3,-1180.2,2736.7,2264.4);


(lib.Popup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {success:0,failure:1,skip:2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Images
	this.slot1 = new lib.FailurePopupActorSlot();
	this.slot1.name = "slot1";
	this.slot1.setTransform(176.2,214.7,1,1,0,0,0,0.1,67.7);

	this.slot0 = new lib.FailurePopupActorSlot();
	this.slot0.name = "slot0";
	this.slot0.setTransform(-153.25,214.7,1,1,0,0,0,0.1,67.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.slot0},{t:this.slot1}]},1).to({state:[]},1).to({state:[]},1).wait(1));

	// continueButton
	this.continueButton = new lib.StartGameButtonWide();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).to({_off:true},3).wait(1));

	// cancelButton
	this.cancelButton = new lib.PrevButton();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(-318.7,720,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.cancelButton).to({_off:true},3).wait(1));

	// titleTextfield
	this.titleTextfield = new cjs.Text("titleTextfield", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).to({_off:true},3).wait(1));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("bodyTextfield\nline2", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 79;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-434.6,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).to({_off:true},3).wait(1));

	// panel bg
	this.instance = new lib.BigPanelBG();
	this.instance.setTransform(-524,-872);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},3).wait(1));

	// PopupBG
	this.instance_1 = new lib.PopUpBG();
	this.instance_1.setTransform(-505,-844);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:true},3).wait(1));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).to({_off:true},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-672.8,-1079.1,1752.8,2340.7);


(lib.LevelRules_wolfwolffoxchickenworm = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor4 = new lib.ChickenSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor5 = new lib.WormSkin();
	this.actor5.name = "actor5";
	this.actor5.setTransform(243.3,429.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.ChickenSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,457.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor6 = new lib.ChickenSkin();
	this.actor6.name = "actor6";
	this.actor6.setTransform(243.3,186.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.FoxSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,186.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor2 = new lib.WolfSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-249.5,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor7 = new lib.FoxSkin();
	this.actor7.name = "actor7";
	this.actor7.setTransform(243.3,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor3 = new lib.WolfSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(-249.5,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor3},{t:this.actor7},{t:this.actor2},{t:this.actor1},{t:this.actor6},{t:this.actor0},{t:this.actor5},{t:this.actor4}]}).wait(1));

	// text in movieclips
	this.actorName_worm = new lib.RulesActorName();
	this.actorName_worm.name = "actorName_worm";
	this.actorName_worm.setTransform(252.15,550.1);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,550.1);

	this.eat3 = new lib.RulesEats();
	this.eat3.name = "eat3";
	this.eat3.setTransform(1.6,451.7,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,275.4);

	this.actorName_fox = new lib.RulesActorName();
	this.actorName_fox.name = "actorName_fox";
	this.actorName_fox.setTransform(-240.65,275.4);

	this.eat2 = new lib.RulesEats();
	this.eat2.name = "eat2";
	this.eat2.setTransform(1.6,177,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_2 = new lib.RulesActorName();
	this.actorName_chicken_2.name = "actorName_chicken_2";
	this.actorName_chicken_2.setTransform(252.15,4.7);

	this.actorName_wolf = new lib.RulesActorName();
	this.actorName_wolf.name = "actorName_wolf";
	this.actorName_wolf.setTransform(-240.65,4.7);

	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,-93.7,1,1,0,0,0,1.6,-2);

	this.actorName_fox_1 = new lib.RulesActorName();
	this.actorName_fox_1.name = "actorName_fox_1";
	this.actorName_fox_1.setTransform(252.15,-269.95);

	this.actorName_wolf_1 = new lib.RulesActorName();
	this.actorName_wolf_1.name = "actorName_wolf_1";
	this.actorName_wolf_1.setTransform(-240.65,-269.95);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,-368.35,1,1,0,0,0,1.6,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.eat0},{t:this.actorName_wolf_1},{t:this.actorName_fox_1},{t:this.eat1},{t:this.actorName_wolf},{t:this.actorName_chicken_2},{t:this.eat2},{t:this.actorName_fox},{t:this.actorName_chicken_1},{t:this.eat3},{t:this.actorName_chicken},{t:this.actorName_worm}]}).wait(1));

	// texts
	this.text1 = new cjs.Text("xIf left unattended:", "39px 'Poppins Medium'", "#0F5184");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 69;
	this.text1.lineWidth = 877;
	this.text1.parent = this;
	this.text1.setTransform(28.0991,-609.8516);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get(this.text1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_wolfwolffoxchickenworm, new cjs.Rectangle(-412.2,-611.8,880.7,1208.9), null);


(lib.LevelRules_wolfdogchickenworm = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor3 = new lib.DogSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(-14.5,556.3,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor4 = new lib.WormSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,67.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.ChickenSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,93.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor5 = new lib.ChickenSkin();
	this.actor5.name = "actor5";
	this.actor5.setTransform(243.3,-179.25,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.WolfSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,-179.25,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor6 = new lib.DogSkin();
	this.actor6.name = "actor6";
	this.actor6.setTransform(243.3,-450.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor2 = new lib.WolfSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-249.5,-450.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor2},{t:this.actor6},{t:this.actor1},{t:this.actor5},{t:this.actor0},{t:this.actor4},{t:this.actor3}]}).wait(1));

	// text in movieclips
	this.actorName_dog = new lib.RulesActorName();
	this.actorName_dog.name = "actorName_dog";
	this.actorName_dog.setTransform(-5.65,646.95);

	this.actorName_worm = new lib.RulesActorName();
	this.actorName_worm.name = "actorName_worm";
	this.actorName_worm.setTransform(252.15,181.4);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,181.4);

	this.eat2 = new lib.RulesEats();
	this.eat2.name = "eat2";
	this.eat2.setTransform(1.6,83,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,-89.3);

	this.actorName_wolf = new lib.RulesActorName();
	this.actorName_wolf.name = "actorName_wolf";
	this.actorName_wolf.setTransform(-240.65,-89.3);

	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,-187.7,1,1,0,0,0,1.6,-2);

	this.actorName_dog_1 = new lib.RulesActorName();
	this.actorName_dog_1.name = "actorName_dog_1";
	this.actorName_dog_1.setTransform(252.15,-359.95);

	this.actorName_wolf_1 = new lib.RulesActorName();
	this.actorName_wolf_1.name = "actorName_wolf_1";
	this.actorName_wolf_1.setTransform(-240.65,-359.95);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,-462.35,1,1,0,0,0,1.6,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.eat0},{t:this.actorName_wolf_1},{t:this.actorName_dog_1},{t:this.eat1},{t:this.actorName_wolf},{t:this.actorName_chicken_1},{t:this.eat2},{t:this.actorName_chicken},{t:this.actorName_worm},{t:this.actorName_dog}]}).wait(1));

	// Layer_1
	this.text1 = new cjs.Text("xIf left unattended:", "39px 'Poppins Medium'", "#0F5184");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 57;
	this.text1.lineWidth = 877;
	this.text1.parent = this;
	this.text1.setTransform(-0.0509,-696.5516);
ranj.TextOffsetFixer.fix(this.text1);

	this.text2 = new cjs.Text("xThe dog protects the worm from being eaten.", "39px 'Poppins Medium'", "#0F5184");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 54;
	this.text2.lineWidth = 689;
	this.text2.parent = this;
	this.text2.setTransform(-14.3022,284.9995);
ranj.TextOffsetFixer.fix(this.text2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text2},{t:this.text1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_wolfdogchickenworm, new cjs.Rectangle(-440.3,-698.5,880.6,1392.5), null);


(lib.LevelRules_foxchickenworm = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors 
	this.actor2 = new lib.FarmerSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-44.45,-448.7,0.55,0.55,0,0,0,-10.8,-29.6);

	this.instance = new lib.Ferry();
	this.instance.setTransform(-169,-551,0.5,0.5);

	this.actor3 = new lib.WormSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(243.3,526.3,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.ChickenSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,548.3,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor4 = new lib.ChickenSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,275.6,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.FoxSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,275.6,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor1},{t:this.actor4},{t:this.actor0},{t:this.actor3},{t:this.instance},{t:this.actor2}]}).wait(1));

	// actornames
	this.actorName_worm = new lib.RulesActorName();
	this.actorName_worm.name = "actorName_worm";
	this.actorName_worm.setTransform(252.15,638.95);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,638.95);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,366.25);

	this.actorName_fox = new lib.RulesActorName();
	this.actorName_fox.name = "actorName_fox";
	this.actorName_fox.setTransform(-240.65,366.25);

	this.actorName_farmer = new lib.RulesActorName();
	this.actorName_farmer.name = "actorName_farmer";
	this.actorName_farmer.setTransform(-5.65,-231.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actorName_farmer},{t:this.actorName_fox},{t:this.actorName_chicken_1},{t:this.actorName_chicken},{t:this.actorName_worm}]}).wait(1));

	// Layer_1
	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,538.75,1,1,0,0,0,1.6,-2);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,267.85,1,1,0,0,0,1.6,-2);

	this.text2 = new cjs.Text("xIf left unattended:", "39px 'Poppins Medium'", "#0F5184");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 69;
	this.text2.lineWidth = 877;
	this.text2.parent = this;
	this.text2.setTransform(-1.9509,64.5484);
ranj.TextOffsetFixer.fix(this.text2);

	this.text1 = new cjs.Text("xThe farmer prevents characters from eating each other.", "39px 'Poppins Medium'", "#0F5184");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 54;
	this.text1.lineWidth = 879;
	this.text1.parent = this;
	this.text1.setTransform(-0.9509,-141.2005);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text1},{t:this.text2},{t:this.eat0},{t:this.eat1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_foxchickenworm, new cjs.Rectangle(-442.2,-595.7,882.5999999999999,1281.7), null);


(lib.LevelRules_foxchickenspidercaterpillarcarrot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor4 = new lib.CarrotSkin();
	this.actor4.name = "actor4";
	this.actor4.setTransform(243.3,427.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor0 = new lib.CaterpillarSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-249.5,435.45,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor5 = new lib.CaterpillarSkin();
	this.actor5.name = "actor5";
	this.actor5.setTransform(243.3,162.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor1 = new lib.SpiderSkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-249.5,186.75,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor6 = new lib.SpiderSkin();
	this.actor6.name = "actor6";
	this.actor6.setTransform(243.3,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor2 = new lib.ChickenSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-249.5,-85.95,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor7 = new lib.ChickenSkin();
	this.actor7.name = "actor7";
	this.actor7.setTransform(243.3,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.actor3 = new lib.FoxSkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(-249.5,-357.65,0.65,0.65,0,0,0,-10.6,-29.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor3},{t:this.actor7},{t:this.actor2},{t:this.actor6},{t:this.actor1},{t:this.actor5},{t:this.actor0},{t:this.actor4}]}).wait(1));

	// text in movieclips
	this.actorName_carrot = new lib.RulesActorName();
	this.actorName_carrot.name = "actorName_carrot";
	this.actorName_carrot.setTransform(252.15,552.1);

	this.actorName_caterpillar = new lib.RulesActorName();
	this.actorName_caterpillar.name = "actorName_caterpillar";
	this.actorName_caterpillar.setTransform(-240.65,552.1);

	this.eat3 = new lib.RulesEats();
	this.eat3.name = "eat3";
	this.eat3.setTransform(1.6,453.7,1,1,0,0,0,1.6,-2);

	this.actorName_caterpillar_1 = new lib.RulesActorName();
	this.actorName_caterpillar_1.name = "actorName_caterpillar_1";
	this.actorName_caterpillar_1.setTransform(252.15,277.4);

	this.actorName_spider = new lib.RulesActorName();
	this.actorName_spider.name = "actorName_spider";
	this.actorName_spider.setTransform(-240.65,277.4);

	this.eat2 = new lib.RulesEats();
	this.eat2.name = "eat2";
	this.eat2.setTransform(1.6,179,1,1,0,0,0,1.6,-2);

	this.actorName_spider_1 = new lib.RulesActorName();
	this.actorName_spider_1.name = "actorName_spider_1";
	this.actorName_spider_1.setTransform(252.15,6.7);

	this.actorName_chicken = new lib.RulesActorName();
	this.actorName_chicken.name = "actorName_chicken";
	this.actorName_chicken.setTransform(-240.65,6.7);

	this.eat1 = new lib.RulesEats();
	this.eat1.name = "eat1";
	this.eat1.setTransform(1.6,-91.7,1,1,0,0,0,1.6,-2);

	this.actorName_chicken_1 = new lib.RulesActorName();
	this.actorName_chicken_1.name = "actorName_chicken_1";
	this.actorName_chicken_1.setTransform(252.15,-267.95);

	this.actorName_fox = new lib.RulesActorName();
	this.actorName_fox.name = "actorName_fox";
	this.actorName_fox.setTransform(-240.65,-267.95);

	this.eat0 = new lib.RulesEats();
	this.eat0.name = "eat0";
	this.eat0.setTransform(1.6,-366.35,1,1,0,0,0,1.6,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.eat0},{t:this.actorName_fox},{t:this.actorName_chicken_1},{t:this.eat1},{t:this.actorName_chicken},{t:this.actorName_spider_1},{t:this.eat2},{t:this.actorName_spider},{t:this.actorName_caterpillar_1},{t:this.eat3},{t:this.actorName_caterpillar},{t:this.actorName_carrot}]}).wait(1));

	// texts
	this.text1 = new cjs.Text("xIf left unattended:", "39px 'Poppins Medium'", "#0F5184");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 69;
	this.text1.lineWidth = 877;
	this.text1.parent = this;
	this.text1.setTransform(-0.0509,-572.5016);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get(this.text1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_foxchickenspidercaterpillarcarrot, new cjs.Rectangle(-440.3,-574.5,880.6,1173.6), null);


(lib.LevelRules_familyOf5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor3 = new lib.Kid3Skin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(101.5,155.35,0.7,0.7,0,0,0,0,-5.5);

	this.actor3_1 = new lib.BoySkin();
	this.actor3_1.name = "actor3_1";
	this.actor3_1.setTransform(212.3,159.55,0.7,0.7,0,0,0,0,-5.5);

	this.actor2 = new lib.WomanSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-1.4,529.5,0.7,0.7,0,0,0,0,-5.5);

	this.actor0 = new lib.GirlSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(-167.45,154.9,0.7,0.7,0,0,0,0,-5.5);

	this.actor1 = new lib.BoySkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-17.4,-266.9,0.5,0.5,0,0,0,0,-4.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor1},{t:this.actor0},{t:this.actor2},{t:this.actor3_1},{t:this.actor3}]}).wait(1));

	// bitmaps
	this.instance = new lib.Ferry();
	this.instance.setTransform(-169,-413,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text in movieclips
	this.actorName_adult1 = new lib.RulesActorName();
	this.actorName_adult1.name = "actorName_adult1";
	this.actorName_adult1.setTransform(0.2,608.8);

	this.actorName_kid2 = new lib.RulesActorName();
	this.actorName_kid2.name = "actorName_kid2";
	this.actorName_kid2.setTransform(158.8,234.2);

	this.actorName_kid1 = new lib.RulesActorName();
	this.actorName_kid1.name = "actorName_kid1";
	this.actorName_kid1.setTransform(-167.25,234.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actorName_kid1},{t:this.actorName_kid2},{t:this.actorName_adult1}]}).wait(1));

	// texts
	this.text3 = new cjs.Text("xOR", "39px 'Poppins Medium'", "#0F5184");
	this.text3.name = "text3";
	this.text3.textAlign = "center";
	this.text3.lineHeight = 69;
	this.text3.lineWidth = 875;
	this.text3.parent = this;
	this.text3.setTransform(-2.9509,300.2477);
ranj.TextOffsetFixer.fix(this.text3);

	this.text2 = new cjs.Text("xThe ferry can carry a maximum of:", "39px 'Poppins Medium'", "#0F5184");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 54;
	this.text2.lineWidth = 865;
	this.text2.parent = this;
	this.text2.setTransform(-7.9509,-87.5023);
ranj.TextOffsetFixer.fix(this.text2);

	this.text1 = new cjs.Text("xThe ferry can only cross when there is at least one person on it.", "39px 'Poppins Medium'", "#0F5184");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 54;
	this.text1.lineWidth = 881;
	this.text1.parent = this;
	this.text1.setTransform(0.0491,-582.2505);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text1},{t:this.text2},{t:this.text3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_familyOf5, new cjs.Rectangle(-442.2,-584.2,884.5999999999999,1240), null);


(lib.LevelRules_familyOf4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actors
	this.actor3 = new lib.BoySkin();
	this.actor3.name = "actor3";
	this.actor3.setTransform(212.3,174.15,0.7,0.7,0,0,0,0,-5.5);

	this.actor0 = new lib.GirlSkin();
	this.actor0.name = "actor0";
	this.actor0.setTransform(103.95,169.95,0.7,0.7,0,0,0,0,-5.5);

	this.actor2 = new lib.ManSkin();
	this.actor2.name = "actor2";
	this.actor2.setTransform(-1.4,544.55,0.7,0.7,0,0,0,0,-5.5);

	this.actor0_1 = new lib.GirlSkin();
	this.actor0_1.name = "actor0_1";
	this.actor0_1.setTransform(-167.45,169.95,0.7,0.7,0,0,0,0,-5.5);

	this.actor1 = new lib.BoySkin();
	this.actor1.name = "actor1";
	this.actor1.setTransform(-17.4,-278.9,0.5,0.5,0,0,0,0,-4.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actor1},{t:this.actor0_1},{t:this.actor2},{t:this.actor0},{t:this.actor3}]}).wait(1));

	// bitmaps
	this.instance = new lib.Ferry();
	this.instance.setTransform(-169,-425,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// actorNames
	this.actorName_adult1 = new lib.RulesActorName();
	this.actorName_adult1.name = "actorName_adult1";
	this.actorName_adult1.setTransform(0.2,616.05);

	this.actorName_kid2 = new lib.RulesActorName();
	this.actorName_kid2.name = "actorName_kid2";
	this.actorName_kid2.setTransform(158.8,245.35);

	this.actorName_kid1 = new lib.RulesActorName();
	this.actorName_kid1.name = "actorName_kid1";
	this.actorName_kid1.setTransform(-167.25,245.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.actorName_kid1},{t:this.actorName_kid2},{t:this.actorName_adult1}]}).wait(1));

	// texts
	this.text3 = new cjs.Text("xOR", "39px 'Poppins Medium'", "#0F5184");
	this.text3.name = "text3";
	this.text3.textAlign = "center";
	this.text3.lineHeight = 69;
	this.text3.lineWidth = 875;
	this.text3.parent = this;
	this.text3.setTransform(-2.9509,315.2977);
ranj.TextOffsetFixer.fix(this.text3);

	this.text2 = new cjs.Text("xThe ferry can carry a maximum of:", "39px 'Poppins Medium'", "#0F5184");
	this.text2.name = "text2";
	this.text2.textAlign = "center";
	this.text2.lineHeight = 54;
	this.text2.lineWidth = 865;
	this.text2.parent = this;
	this.text2.setTransform(-7.9509,-87.5023);
ranj.TextOffsetFixer.fix(this.text2);

	this.text1 = new cjs.Text("xThe ferry can only cross when there is at least one person on it.", "39px 'Poppins Medium'", "#0F5184");
	this.text1.name = "text1";
	this.text1.textAlign = "center";
	this.text1.lineHeight = 56;
	this.text1.lineWidth = 881;
	this.text1.parent = this;
	this.text1.setTransform(0.0491,-588.8505);
ranj.TextOffsetFixer.fix(this.text1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text1},{t:this.text2},{t:this.text3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelRules_familyOf4, new cjs.Rectangle(-442.2,-590.8,884.5999999999999,1253.9), null);


(lib.GatekeeperOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(107.4,73.2,1,1,0,0,0,0,3.1);

	this.titleTextfield = new cjs.Text("[Title]", "28px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 34;
	this.titleTextfield.lineWidth = 382;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-195.95,-91.5021);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.replayButton = new lib.PrevButton();
	this.replayButton.name = "replayButton";
	this.replayButton.setTransform(-130.75,69.9,1,1,0,0,0,-40.8,0.3);

	this.bodyTextfield = new cjs.Text("• [Instructions]", "28px 'Roboto Medium'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 34;
	this.bodyTextfield.lineWidth = 382;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-195.95,-41.6521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bodyTextfield},{t:this.replayButton},{t:this.titleTextfield},{t:this.startButton}]}).wait(1));

	// Panels
	this.panel = new lib.DummyTutorialStepPanel();
	this.panel.name = "panel";
	this.panel.setTransform(-6,2.45);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperOverlaySkin, new cjs.Rectangle(-663.5,-1180.2,1746.9,2239.2), null);


(lib.RulesPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {familyOf4:0,foxchickenworm:1,wolfwolffoxchickenworm:2,wolfdogchickenworm:3,familyOf5:4,foxchickenspidercaterpillarcarrot:5};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// level contents
	this.level_familyOf4 = new lib.LevelRules_familyOf4();
	this.level_familyOf4.name = "level_familyOf4";
	this.level_familyOf4.setTransform(-30.7,590.85,1,1,0,0,0,-30.7,0);

	this.level_foxchickenworm = new lib.LevelRules_foxchickenworm();
	this.level_foxchickenworm.name = "level_foxchickenworm";
	this.level_foxchickenworm.setTransform(-36.1,591.7,1,1,0,0,0,-36.1,0);

	this.level_wolfwolffoxchickenworm = new lib.LevelRules_wolfwolffoxchickenworm();
	this.level_wolfwolffoxchickenworm.name = "level_wolfwolffoxchickenworm";
	this.level_wolfwolffoxchickenworm.setTransform(-65.85,611.85,1,1,0,0,0,-36.1,0);

	this.level_wolfdogchickenworm = new lib.LevelRules_wolfdogchickenworm();
	this.level_wolfdogchickenworm.name = "level_wolfdogchickenworm";
	this.level_wolfdogchickenworm.setTransform(-36.95,695.7,1,1,0,0,0,-36.1,0);

	this.level_familyOf5 = new lib.LevelRules_familyOf5();
	this.level_familyOf5.name = "level_familyOf5";
	this.level_familyOf5.setTransform(-30.7,584.25,1,1,0,0,0,-30.7,0);

	this.level_foxchickenspidercaterpillarcarrot = new lib.LevelRules_foxchickenspidercaterpillarcarrot();
	this.level_foxchickenspidercaterpillarcarrot.name = "level_foxchickenspidercaterpillarcarrot";
	this.level_foxchickenspidercaterpillarcarrot.setTransform(-36.95,574.5,1,1,0,0,0,-36.1,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.level_familyOf4}]}).to({state:[{t:this.level_foxchickenworm}]},1).to({state:[{t:this.level_wolfwolffoxchickenworm}]},1).to({state:[{t:this.level_wolfdogchickenworm}]},1).to({state:[{t:this.level_familyOf5}]},1).to({state:[{t:this.level_foxchickenspidercaterpillarcarrot}]},1).wait(1));

	// toggle
	this.closeInstructionsTextfield = new cjs.Text("Tap to close", "39px 'Poppins SemiBold'", "#0F5184");
	this.closeInstructionsTextfield.name = "closeInstructionsTextfield";
	this.closeInstructionsTextfield.lineHeight = 69;
	this.closeInstructionsTextfield.lineWidth = 594;
	this.closeInstructionsTextfield.parent = this;
	this.closeInstructionsTextfield.setTransform(-275.65,1409.7);
ranj.TextOffsetFixer.fix(this.closeInstructionsTextfield);

	this.toggle = new lib.ArrowButton();
	this.toggle.name = "toggle";
	this.toggle.setTransform(-354.5,1437.45,1,1,0,0,0,11,-0.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.toggle},{t:this.closeInstructionsTextfield}]}).wait(6));

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhD6BiZQkrAAjTjTQjSjTAAkqMAAAiuRQAAkqDSjTQDTjTErAAMCH1AAAQErAADSDTQDTDTAAEqMAAACuRQAAEqjTDTQjSDTkrAAg");
	this.shape.setTransform(6.325,693.3718,1,1.3438);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(6));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-560,-152.7,1125,1757.5);


(lib.RulesPanelContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// content (closed)
	this.contents = new lib.RulesPanel();
	this.contents.name = "contents";
	this.contents.setTransform(-6.65,-1733.5,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.contents).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RulesPanelContainer, new cjs.Rectangle(-507.5,-1886.1,1013.4,3425.6), null);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// popup
	this.popup = new lib.Popup();
	this.popup.name = "popup";
	this.popup.setTransform(-18,4.4);

	this.timeline.addTween(cjs.Tween.get(this.popup).wait(1));

	// rules
	this.rulesPanel = new lib.RulesPanelContainer();
	this.rulesPanel.name = "rulesPanel";
	this.rulesPanel.setTransform(2.75,-697.3,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.rulesPanel).wait(1));

	// elements
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(255.15,-839.95);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// skip button
	this.skipButton = new lib.SkipButton();
	this.skipButton.name = "skipButton";
	this.skipButton.setTransform(372.1,-598.65,1,1,0,0,0,-0.1,2.6);

	this.timeline.addTween(cjs.Tween.get(this.skipButton).wait(1));

	// feedback
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(9.1,185.9,1,1,0,0,0,0.2,183.5);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// row button
	this.rowButton = new lib.StartGameButtonWide();
	this.rowButton.name = "rowButton";
	this.rowButton.setTransform(49.9,718.2,1,0.9999,0,0,0,-0.1,2.7);

	this.timeline.addTween(cjs.Tween.get(this.rowButton).wait(1));

	// level placeholder
	this.levelContainer = new lib.PlaceholderRound();
	this.levelContainer.name = "levelContainer";

	this.timeline.addTween(cjs.Tween.get(this.levelContainer).wait(1));

	// river
	this.instance = new lib.River();
	this.instance.setTransform(-666,-497);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg_elements
	this.instance_1 = new lib.RiverbankDown_1();
	this.instance_1.setTransform(-6.5,375.6,1,1,0,0,0,666.5,407.6);

	this.instance_2 = new lib.RiverbankUp_1();
	this.instance_2.setTransform(-6.5,-136.4,1,1,0,0,0,666.5,407.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// bg
	this.openRulesButton = new lib.CastPanelButton();
	this.openRulesButton.name = "openRulesButton";
	this.openRulesButton.setTransform(-397.5,-787.5,1,1,0,0,0,102.5,50.5);

	this.bg = new lib.GameScreenBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.openRulesButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-690.8,-2582.9,1770.2,3657.6000000000004), null);


// stage content:
(lib.MainAssetsRedesign = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// assets
	this.instance = new lib.WormSkin();
	this.instance.setTransform(1914.8,1938.8,1,1,0,0,0,2,-24.5);

	this.instance_1 = new lib.CarrotSkin();
	this.instance_1.setTransform(2016.15,568.15,1,1,0,0,0,2,-15.5);

	this.instance_2 = new lib.CaterpillarSkin();
	this.instance_2.setTransform(2083.3,1720.9,1,1,0,0,0,2,-53.5);

	this.instance_3 = new lib.LevelWith2SlotsSkin();
	this.instance_3.setTransform(2615.15,3797.15);

	this.instance_4 = new lib.GirlSkin();
	this.instance_4.setTransform(1506.85,826.55,1,1,0,0,0,2,-38);

	this.instance_5 = new lib.GooseSkin();
	this.instance_5.setTransform(1854.85,1721.6,1,1,0,0,0,2,-53.5);

	this.instance_6 = new lib.Boat3SkinNoSeats();
	this.instance_6.setTransform(1561.2,-1531.2,1,1,0,0,0,95.5,-147);

	this.instance_7 = new lib.CabbageSkin();
	this.instance_7.setTransform(1472.4,568.15,1,1,0,0,0,2,-15.5);

	this.instance_8 = new lib.Boat2SkinNoSeats();
	this.instance_8.setTransform(1522.7,-890.4,1,1,0,0,0,6.2,-40.2);

	this.instance_9 = new lib.BagSkin();
	this.instance_9.setTransform(1660.6,1443.9);

	this.instance_10 = new lib.DogSkin();
	this.instance_10.setTransform(1847.35,1440.5,1,1,0,0,0,-5.5,-24.4);

	this.instance_11 = new lib.LevelWith3SlotsSkin();
	this.instance_11.setTransform(2639.2,2519.25);

	this.instance_12 = new lib.Kid3Skin();
	this.instance_12.setTransform(1868.85,859.05,1,1,0,0,0,0,-5.5);

	this.instance_13 = new lib.BoySkin();
	this.instance_13.setTransform(1680.1,876.35,1,1,0,0,0,-0.1,-4.2);

	this.instance_14 = new lib.WomanSkin();
	this.instance_14.setTransform(1723.7,1123,1,1,0,0,0,13.5,-19.8);

	this.instance_15 = new lib.ManSkin();
	this.instance_15.setTransform(1508.95,1114.65,1,1,0,0,0,7,-20.3);

	this.instance_16 = new lib.LevelWith6SlotsSkin();
	this.instance_16.setTransform(2696.8,-822.5);

	this.instance_17 = new lib.SpiderSkin();
	this.instance_17.setTransform(1453,1746.4);

	this.instance_18 = new lib.LevelWith4SlotsSkin();
	this.instance_18.setTransform(2723.05,1281.2);

	this.instance_19 = new lib.SnailSkin();
	this.instance_19.setTransform(1653.55,1752.4,1,1,0,0,0,-1,-12);

	this.instance_20 = new lib.FoxSkin();
	this.instance_20.setTransform(1501.05,1973.9,1,1,0,0,0,-10.5,-29.5);

	this.instance_21 = new lib.ChickenSkin();
	this.instance_21.setTransform(1443.1,1446.3);

	this.instance_22 = new lib.Boat3Skin();
	this.instance_22.setTransform(1522.7,-55.7,1,1,0,0,0,6.2,-40.2);

	this.instance_23 = new lib.Boat2Skin();
	this.instance_23.setTransform(1522.7,-477.3,1,1,0,0,0,6.2,-41.6);

	this.instance_24 = new lib.LevelWith5SlotsSkin();
	this.instance_24.setTransform(2696.8,257.95);

	this.instance_25 = new lib.WolfSkin();
	this.instance_25.setTransform(1758.4,418.2);

	this.instance_26 = new lib.GoatSkin();
	this.instance_26.setTransform(1518.1,384.15);

	this.instance_27 = new lib.FarmerSkin();
	this.instance_27.setTransform(1763.25,597);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// tutorial
	this.instance_28 = new lib.TutorialOverlaySkin();
	this.instance_28.setTransform(539.7,3389.45,1,1,0,0,0,3.8,-0.3);
	this.instance_28.cache(-1655,-1182,2741,2268);

	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(1));

	// gamescreen
	this.instance_29 = new lib.EndScreenSkin();
	this.instance_29.setTransform(-1041.5,870.95,1,1,0,0,0,0.5,-0.1);

	this.instance_30 = new lib.GameScreenSkin();
	this.instance_30.setTransform(539.8,862.6,1,1,0,0,0,-0.2,-8.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_30},{t:this.instance_29}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-1168,-927.2,4927.1,5711.4);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/BackDisabled.png", id:"MainAssets_BackDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackDown.png", id:"MainAssets_BackDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackUp.png", id:"MainAssets_BackUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BigPanelBG.png", id:"MainAssets_BigPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Boy.png", id:"MainAssets_Boy", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Boy_ClosedEyes.png", id:"MainAssets_Boy_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Cabbage.png", id:"MainAssets_Cabbage", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Carrot.png", id:"MainAssets_Carrot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Caterpillar.png", id:"MainAssets_Caterpillar", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Caterpillar_ClosedEyes.png", id:"MainAssets_Caterpillar_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterShadow.png", id:"MainAssets_CharacterShadow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Chicken.png", id:"MainAssets_Chicken", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Chicken__ClosedEyes.png", id:"MainAssets_Chicken__ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CloseButtonDis.png", id:"MainAssets_CloseButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CloseButtonhi.png", id:"MainAssets_CloseButtonhi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CloseButtonUp.png", id:"MainAssets_CloseButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dog.png", id:"MainAssets_Dog", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Dog_ClosedEyes.png", id:"MainAssets_Dog_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Euromast.png", id:"MainAssets_Euromast", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Farmer.png", id:"MainAssets_Farmer", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Farmer_ClosedEyes.png", id:"MainAssets_Farmer_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Father.png", id:"MainAssets_Father", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Father_ClosedEyes.png", id:"MainAssets_Father_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPanelBg.png", id:"MainAssets_FeedbackPanelBg", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ferry.png", id:"MainAssets_Ferry", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ferry_ClosedEyes.png", id:"MainAssets_Ferry_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ferry_Practice_RoundBG.png", id:"MainAssets_Ferry_Practice_RoundBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish_01.png", id:"MainAssets_Fish_01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fish_02.png", id:"MainAssets_Fish_02", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Foreground_Splash.png", id:"MainAssets_Foreground_Splash", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fox.png", id:"MainAssets_Fox", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Fox_ClosedEyes.png", id:"MainAssets_Fox_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Girl.png", id:"MainAssets_Girl", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Girl_ClosedEyes.png", id:"MainAssets_Girl_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goat.png", id:"MainAssets_Goat", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goat_ClosedEyes.png", id:"MainAssets_Goat_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goose.png", id:"MainAssets_Goose", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Goose_ClosedEyes.png", id:"MainAssets_Goose_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Grass.png", id:"MainAssets_Grass", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/GreyBackground.png", id:"MainAssets_GreyBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Kabouter.png", id:"MainAssets_Kabouter", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Kid.png", id:"MainAssets_Kid", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Kid_ClosedEyes.png", id:"MainAssets_Kid_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonDis.png", id:"MainAssets_LongerMainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonDown.png", id:"MainAssets_LongerMainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonHi.png", id:"MainAssets_LongerMainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonUp.png", id:"MainAssets_LongerMainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDis.png", id:"MainAssets_MainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDisMedium.png", id:"MainAssets_MainButtonDisMedium", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDown.png", id:"MainAssets_MainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDownMedium.png", id:"MainAssets_MainButtonDownMedium", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonHi.png", id:"MainAssets_MainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonHiMedium.png", id:"MainAssets_MainButtonHiMedium", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonUp.png", id:"MainAssets_MainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonUpMedium.png", id:"MainAssets_MainButtonUpMedium", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Mill.png", id:"MainAssets_Mill", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Mother.png", id:"MainAssets_Mother", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Mother_ClosedEyes.png", id:"MainAssets_Mother_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PopUpBG.png", id:"MainAssets_PopUpBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerTutorialPanel2.png", id:"MainAssets_RacerTutorialPanel2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerTutorialPanel3.png", id:"MainAssets_RacerTutorialPanel3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerTutorialPanel4.png", id:"MainAssets_RacerTutorialPanel4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/River.png", id:"MainAssets_River", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RiverbankDown.png", id:"MainAssets_RiverbankDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RiverbankUp.png", id:"MainAssets_RiverbankUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SackGrain.png", id:"MainAssets_SackGrain", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Skip_disabled.png", id:"MainAssets_Skip_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Skip_down.png", id:"MainAssets_Skip_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Skip_up.png", id:"MainAssets_Skip_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SkipDown.png", id:"MainAssets_SkipDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SlotArea.png", id:"MainAssets_SlotArea", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Snail.png", id:"MainAssets_Snail", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Snail_ClosedEyes.png", id:"MainAssets_Snail_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Spider.png", id:"MainAssets_Spider", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Spider_ClosedEyes.png", id:"MainAssets_Spider_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SplashBGPanel.png", id:"MainAssets_SplashBGPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonBGBirds.png", id:"MainAssets_TabButtonBGBirds", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonBGBirdsDown.png", id:"MainAssets_TabButtonBGBirdsDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonBirdsIconDis.png", id:"MainAssets_TabButtonBirdsIconDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonBirdsIconUp.png", id:"MainAssets_TabButtonBirdsIconUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Tree.png", id:"MainAssets_Tree", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutorialPanelArrow.png", id:"MainAssets_TutorialPanelArrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/White_LevelFill_Ferry.png", id:"MainAssets_White_LevelFill_Ferry", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/WhiteArrow.png", id:"MainAssets_WhiteArrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Wolf.png", id:"MainAssets_Wolf", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Wolf_ClosedEyes.png", id:"MainAssets_Wolf_ClosedEyes", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Worm.png", id:"MainAssets_Worm", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Worm_ClosedEyes.png", id:"MainAssets_Worm_ClosedEyes", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;